module.exports = __webpack_public_path__ + "media/images/illustrations/coins-e3f318b70a2d9ca6e308533fa40be7fb.svg";